import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { NonNegativeMonetaryValue } from '../fields';

// Field is `loanId` (not `loanNumber`) because processLoanImport resolves the loan from row.loanId.
export const RecordTaxAmountReportRow = z.object({
  loanId: LosId,
  apn: z.string(),
  taxAmount: NonNegativeMonetaryValue,
});
export type RecordTaxAmountReportRow = z.infer<typeof RecordTaxAmountReportRow>;
